import { PRIORITY, SETTINGS } from '../../constants';
import { getAssetUrlsFromId } from '../../manifest';
import { isNodeEnvironment } from '../../utils';
import { insertLinkTag } from './utils';
var fakePromise = {
  then: function then() {
    return fakePromise;
  },
  catch: function _catch() {
    return fakePromise;
  },
  finally: function _finally() {
    return fakePromise;
  }
};
export function preloadAssetViaManifest(loader, _ref) {
  var moduleId = _ref.moduleId,
      rel = _ref.rel;
  var assets = getAssetUrlsFromId(SETTINGS.MANIFEST, moduleId);

  if (!assets) {
    return false;
  }

  assets.forEach(function (url) {
    return insertLinkTag(url, rel);
  });
  return true;
}
export function preloadAssetViaWebpack(loader, _ref2) {
  var rel = _ref2.rel;
  if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') return false; // replace requireEnsure to create link tags instead of scripts

  var requireEnsure = __webpack_require__.e;

  __webpack_require__.e = function requirePreload(chunkId) {
    var href = __webpack_get_script_filename__(chunkId);

    insertLinkTag(href, rel);
    return fakePromise;
  };

  try {
    loader();
  } catch (err) {} // ignore
  // restore real webpack require ensure


  __webpack_require__.e = requireEnsure;
  return true;
}
export function preloadAssetViaLoader(loader) {
  loader();
  return true;
}
export function preloadAsset(loader, _ref3) {
  var moduleId = _ref3.moduleId,
      priority = _ref3.priority;
  if (isNodeEnvironment()) return;
  var rel = priority === PRIORITY.HIGH ? 'preload' : 'prefetch';
  [preloadAssetViaManifest, preloadAssetViaWebpack, preloadAssetViaLoader].some(function (strategy) {
    return strategy(loader, {
      moduleId: moduleId,
      rel: rel
    });
  });
}